import * as React from 'react';

function CartIcon(props) {
	return (
		<svg xmlns='http://www.w3.org/2000/svg' width={16} height={16} viewBox='0 0 24 24' fill='none' {...props}>
			<path
				d='M2.05 2.05h2l2.66 12.42a2 2 0 002 1.58h9.78a2 2 0 001.95-1.57l1.65-7.43H5.12M9 21a1 1 0 11-2 0 1 1 0 012 0zm11 0a1 1 0 11-2 0 1 1 0 012 0z'
				stroke='#545454'
				strokeWidth={2}
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
}

export default CartIcon;
